import { Typography, Box } from '@mui/material'
import theme from 'lib/theme'
import { formatPrice } from 'lib/utils'
import React from 'react'
import { Product } from 'types/model/product'

export const PriceColumn = ({ product }: { product: Product }) => {
  return (
    <>
      {!product.collectedProduct ||
      Object.keys(product.collectedProduct).length === 0 ? (
        <Box sx={{ height: theme.spacing(9), padding: theme.spacing(1) }}>
          <Typography>{formatPrice(product.rowPrice.priceVat)}</Typography>
        </Box>
      ) : (
        <Box sx={{ height: theme.spacing(9), padding: theme.spacing(1) }}>
          <Typography>
            {formatPrice(product.collectedProduct.rowPrice.priceVat)}
          </Typography>
        </Box>
      )}
      {product.pickingStatus.toLowerCase() === 'substituted' && (
        <Box
          sx={{
            height: theme.spacing(9),
            padding: theme.spacing(1),
          }}>
          <Typography>{formatPrice(product.rowPrice.priceVat)}</Typography>
        </Box>
      )}
    </>
  )
}
